<ix-layout-grid class="h-100 d-flex flex-column">
  <ix-row>
    <ix-col>
      <ix-content-header
        headerTitle="{{ 'overview.menu.passport_dashboard' | translate }}"
        id="ecoSystemSubHeader">
        <ix-button
          *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER']"
          [routerLink]="'/app/list-passports'"
          class="me-3"
          icon="search"
          onkeypress=""
          id="overviewFindPassportsButton"
          variant="tertiary">
          {{ 'overview.menu.find_passports' | translate }}
        </ix-button>
        <ix-button
          (click)="addNewPassportClick()"
          *ngxPermissionsOnly="['DATA_MANAGER']"
          icon="add"
          id="overviewAddPassportButton"
          onkeypress=""
          variant="primary">
          {{ 'battery_pass.create.workflow' | translate }}
        </ix-button>
      </ix-content-header>
    </ix-col>
  </ix-row>
  <ix-row>
    <ix-col size="6" sizeSm="12">
      <app-search-battery-pass
        *ngxPermissionsExcept="['SYS_ADMIN', 'DATA_MANAGER', 'DATA_PROVIDER']"
      ></app-search-battery-pass>
    </ix-col>
  </ix-row>
  <ix-row class="h-100">
    <ix-col>
      <app-battery-dashboard
        *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER']"
      ></app-battery-dashboard>

    </ix-col>
  </ix-row>
  <ix-row>
    <ix-col size="12">
      <ix-typography format="h4">{{
          'overview.topic.section_headline' | translate
        }}
      </ix-typography>
    </ix-col>
    <ix-col size="3" sizeLg="3" sizeMd="3" sizeSm="12">
      <app-topic-card
        [linkTo]="'links.siemens_battery_passport_link' | translate"
        color="--theme-chart-7"
        heading="{{ 'overview.topic.discover.heading' | translate }}"
        icon="battery-full"
        id="ecoSystemTopicDiscover"
        subheading="{{ 'overview.topic.discover.subheading' | translate }}"
      ></app-topic-card>
    </ix-col>
    <ix-col size="3" sizeLg="3" sizeMd="3" sizeSm="12">
      <app-topic-card
        color="--theme-chart-6"
        heading="{{ 'overview.topic.api.heading' | translate }}"
        icon="script"
        id="ecoSystemTopicAPI"
        linkTo="https://developer.siemens.com/battery-passport/rest-api-spec.html"
        subheading="{{ 'overview.topic.api.subheading' | translate }}"
      ></app-topic-card>
    </ix-col>
    <ix-col size="3" sizeLg="3" sizeMd="3" sizeSm="12">
      <app-topic-card
        [linkTo]="'links.tcpcm_link' | translate"
        color="--theme-chart-2"
        heading="{{ 'overview.topic.explore.heading' | translate }}"
        icon="leaf"
        id="ecoSystemTopicTcpcm"
        subheading="{{ 'overview.topic.explore.subheading' | translate }}"
      ></app-topic-card>
    </ix-col>
    <ix-col size="3" sizeLg="3" sizeMd="3" sizeSm="12">
      <app-topic-card
        [linkTo]="'links.user_manual_link' | translate"
        color="--theme-chart-1"
        heading="{{ 'overview.topic.view.heading' | translate }}"
        icon="document"
        id="ecoSystemTopicUserManual"
        subheading="{{ 'overview.topic.view.subheading' | translate }}"
      ></app-topic-card>
    </ix-col>
  </ix-row>
</ix-layout-grid>
